function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PlaneGeometry } from '../geometry';
import Model from '../core/model';
import { uid } from '../utils';

var Plane = function (_Model) {
  _inherits(Plane, _Model);

  function Plane() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Plane);

    var _opts$id = opts.id,
        id = _opts$id === undefined ? uid('plane') : _opts$id;
    return _possibleConstructorReturn(this, (Plane.__proto__ || Object.getPrototypeOf(Plane)).call(this, Object.assign({}, opts, { id: id, geometry: new PlaneGeometry(opts) })));
  }

  return Plane;
}(Model);

export { Plane as default };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvcGxhbmUuanMiXSwibmFtZXMiOlsiUGxhbmVHZW9tZXRyeSIsIk1vZGVsIiwidWlkIiwiUGxhbmUiLCJvcHRzIiwiaWQiLCJPYmplY3QiLCJhc3NpZ24iLCJnZW9tZXRyeSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsU0FBUUEsYUFBUixRQUE0QixhQUE1QjtBQUNBLE9BQU9DLEtBQVAsTUFBa0IsZUFBbEI7QUFDQSxTQUFRQyxHQUFSLFFBQWtCLFVBQWxCOztJQUVxQkMsSzs7O0FBQ25CLG1CQUF1QjtBQUFBLFFBQVhDLElBQVcsdUVBQUosRUFBSTs7QUFBQTs7QUFBQSxtQkFDT0EsSUFEUCxDQUNkQyxFQURjO0FBQUEsUUFDZEEsRUFEYyw0QkFDVEgsSUFBSSxPQUFKLENBRFM7QUFBQSx5R0FFZkksT0FBT0MsTUFBUCxDQUFjLEVBQWQsRUFBa0JILElBQWxCLEVBQXdCLEVBQUNDLE1BQUQsRUFBS0csVUFBVSxJQUFJUixhQUFKLENBQWtCSSxJQUFsQixDQUFmLEVBQXhCLENBRmU7QUFHdEI7OztFQUpnQ0gsSzs7U0FBZEUsSyIsImZpbGUiOiJwbGFuZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7UGxhbmVHZW9tZXRyeX0gZnJvbSAnLi4vZ2VvbWV0cnknO1xuaW1wb3J0IE1vZGVsIGZyb20gJy4uL2NvcmUvbW9kZWwnO1xuaW1wb3J0IHt1aWR9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgUGxhbmUgZXh0ZW5kcyBNb2RlbCB7XG4gIGNvbnN0cnVjdG9yKG9wdHMgPSB7fSkge1xuICAgIGNvbnN0IHtpZCA9IHVpZCgncGxhbmUnKX0gPSBvcHRzO1xuICAgIHN1cGVyKE9iamVjdC5hc3NpZ24oe30sIG9wdHMsIHtpZCwgZ2VvbWV0cnk6IG5ldyBQbGFuZUdlb21ldHJ5KG9wdHMpfSkpO1xuICB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist-es6/models/plane.js
// module id = 572
// module chunks = 0